import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { useShowNotice } from '@atlassian/proforma-utils/show-notice';
import { useFormIndexActions } from '../../store';
import { FormViewMode } from '../../store/types';
import { messages } from '../messages';
import { SubmitResult } from '../types';
import { createSubmitFormError } from './createSubmitErrors';
export const useSubmitForm = projectType => {
  const {
    submitForm,
    updateFormStatus,
    setFormViewMode
  } = useFormIndexActions();
  const {
    showNotice
  } = useShowNotice();
  const confirmSubmitForm = useCallback(async formStore => {
    if (formStore.formId) {
      const updatedForm = await submitForm(formStore.formId, formStore.submitLock);
      await formStore.update(updatedForm);
      formStore.hideValidations();
      setFormViewMode(FormViewMode.View);
      updateFormStatus(updatedForm.id, updatedForm.state.status);
    }
  }, [setFormViewMode, submitForm, updateFormStatus]);
  return {
    submitFormWithConfirmation: useCallback(formStore => new Promise((resolve, reject) => {
      showNotice({
        title: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.confirmSubmitFormNoticeTitle, {
          values: {
            formName: formStore.formName || 'Untitled form'
          }
        })),
        body: projectType === 'service_desk' ? /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmSubmitFormNoticeBody) : /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmSubmitFormNoticeBodyNonJsm),
        closeText: /*#__PURE__*/React.createElement(FormattedMessage, messages.noticeCancelSubmitLabel),
        confirmText: /*#__PURE__*/React.createElement(FormattedMessage, messages.noticeConfirmSubmitLabel),
        onConfirmHandler: () => confirmSubmitForm(formStore).then(() => resolve(SubmitResult.Success)).catch(e => reject(createSubmitFormError(e))),
        onCloseHandler: () => {
          resolve(SubmitResult.Cancelled);
        }
      });
    }), [confirmSubmitForm, projectType, showNotice]),
    submitForm: formStore => confirmSubmitForm(formStore).then(() => SubmitResult.Success).catch(e => {
      throw createSubmitFormError(e);
    })
  };
};